"use client";

import { FC } from "react";
import useTrackUrlHistory from "./useTrackUrlHistroy";

const UrlHistoryTracker: FC = () => {
  // Use the hook to track URL history
  useTrackUrlHistory();
  
  // This component doesn't render anything visible
  return null;
};

export default UrlHistoryTracker;